// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-title[data-v-78b41c46]{width:100%;padding:.11111rem;font-size:.16667rem;display:flex;flex-flow:row;justify-content:space-between;align-items:center;background:#f6f7fa}.page-title span[data-v-78b41c46]{color:#1d1f24;font-weight:500}.page-title .goback[data-v-78b41c46]{cursor:pointer;margin-right:.13889rem;font-size:.11111rem;color:#333}.page-title .goback[data-v-78b41c46]:hover{color:#3c64ef}", ""]);
// Exports
module.exports = exports;
